export const setCookie = (cookieName, cookieValue, expiryHours) => {
    if (cookieValue === false) {
        document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return;
    }    
    var d = new Date();
    d.setTime(d.getTime() + (expiryHours * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }